<div [dragula]="'formfields-' + lang" [(dragulaModel)]="value" class="formfields">
  <ng-container *ngFor="let containedField of value; index as i">
    <div class="grid__row formfields__row" *ngIf="containedField.language === lang">
      <div class="formfields__row__drag-handle drag-handle" title="Přetáhnutím změnit pořadí">
        <i class="ico-drag drag-handle"></i>
      </div>
      <div class="grid__cell grid__cell--quarter formfields__field">
        <div class="input">
          <input type="text" placeholder="Název pole" [(ngModel)]="value[i].label" />
        </div>
      </div>
      <div class="grid__cell grid__cell--quarter formfields__field">
        <div class="input">
          <ng-select [items]="fieldOptions" bindLabel="text" bindValue="value" placeholder=""
            [(ngModel)]="value[i].type"></ng-select>
        </div>
      </div>
      <div class="grid__cell grid__cell--quarter formfields__field">
        <div class="input">
          <label class="switch__label" for="required" style="position: relative; top: 10px;">
            <ui-switch color="#3dcb35" switchColor="#fff" id="required" [(ngModel)]="value[i].required"></ui-switch>
            <div class="switch__label__text">Povinné pole</div>
          </label>
        </div>
      </div>
      <ng-container *ngIf="containedField.type === 'checkbox'">
        <div class="grid__cell grid__cell--quarter formfields__field">
          <div class="input">
            <label class="switch__label" for="field.key" style="position: relative; top: 10px;">
              <ui-switch color="#3dcb35" switchColor="#fff" id="defaultvalue" [(ngModel)]="value[i].defaultValue">
              </ui-switch>
              <div class="switch__label__text">Defaultní hodnota</div>
            </label>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="containedField.type === 'select'">
        <div class="grid__cell grid__cell--quarter formfields__field">
          <div class="input">
            <input type="text" placeholder="seznam hodnot oddělených středníkem (;)"
              [(ngModel)]="value[i].fieldoptions" />
          </div>
        </div>
      </ng-container>
      <a class="row-form__remove" (click)="removeField(i)">
        <i class="ico-remove"></i>
      </a>
    </div>
  </ng-container>
  <a (click)="addField(lang)" class="cta cta--small cta--green formfields__add add-formfield">Přidat formulářové pole
    <i class="ico-plus"></i>
  </a>